import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import NoIndex from "../NoIndex";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ProductStatsModal = ({ data, onClose }) => {
  const chartData = {
    labels: data.map((item) => item.productName),
    datasets: [
      {
        label: "Order Count",
        data: data.map((item) => parseInt(item.orderCount)),
        backgroundColor: "#FF8000",
        borderRadius: 6,
        barThickness: 40,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 0.5 },
        grid: { color: "rgba(0,0,0,0.06)" },
      },
      x: {
        grid: { display: false },
      },
    },
  };

  return (

    <>
    <NoIndex/>
  
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 montserrat-font-1"
      onClick={onClose}
    >

      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-3xl mx-4 overflow-hidden montserrat-font-1"
        style={{ maxHeight: "90vh", display: "flex", flexDirection: "column" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="flex items-center justify-between px-6 py-4 montserrat-font-1"
          style={{ backgroundColor: "white" }}
        >
          <h2 className="text-lg font-bold text-green-500 montserrat-font-1">
            Top Ordered Products
          </h2>
          <button
            onClick={() => onClose()}
            className="flex items-center justify-center text-green-900 font-bold rounded montserrat-font-1"
            style={{
              backgroundColor: "#DCFCE7",
              width: 32,
              height: 32,
              fontSize: 16,
            }}
          >
            ✕
          </button>
        </div>

        {/* Scrollable body */}
        <div style={{ overflowY: "auto", flex: 1 }}>
          <div style={{ height: 3, backgroundColor: "#01c37d" }} />

          {/* Chart */}
          <div className="px-6 pt-4 pb-2 montserrat-font-1">
            <Bar data={chartData} options={options} />
          </div>

          {/* Divider */}
          <div
            style={{ height: 1, backgroundColor: "#DCFCE7", margin: "0 24px" }}
          />


          <div
            className="p-4 montserrat-font-1"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: 12,
            }}
          >
            {data.map((product) => (
              <div
                key={product.productId}
                className="flex items-center gap-3 bg-green-50 rounded-lg p-3 montserrat-font-1"
                style={{
                  border: "1px solid #DCFCE7",
                  borderLeft: "4px solid #01c37d",
                }}
              >
                <img
                  className="rounded-lg object-cover flex-shrink-0"
                  src={product.productImage}
                  alt={product.productName}
                  style={{ width: 56, height: 56 }}
                />
                <div>
                  <h4 className="text-sm font-bold text-green-800 leading-tight montserrat-font-1">
                    {product.productName}
                  </h4>
                  <p className="text-xs text-green-800 mt-0.5 montserrat-font-2">
                    Orders: {product.orderCount}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ProductStatsModal;
